module.exports = __webpack_public_path__ + "img/alert-circle.dafb09a9.svg";